'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dShodo$002dSign$002dRequest from "./presto.-Agent-View$-Local-Shodo-Sign-Request.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$LocalShodoSignRequest$() {
}
export { $c_Lpresto_AgentView$LocalShodoSignRequest$ as $c_Lpresto_AgentView$LocalShodoSignRequest$ };
$p = $c_Lpresto_AgentView$LocalShodoSignRequest$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$LocalShodoSignRequest$;
/** @constructor */
function $h_Lpresto_AgentView$LocalShodoSignRequest$() {
}
export { $h_Lpresto_AgentView$LocalShodoSignRequest$ as $h_Lpresto_AgentView$LocalShodoSignRequest$ };
$h_Lpresto_AgentView$LocalShodoSignRequest$.prototype = $p;
$p.l = (function() {
  return "LocalShodoSignRequest";
});
$p.cFZ = (function(x$0) {
  return new $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dShodo$002dSign$002dRequest.$c_Lpresto_AgentView$LocalShodoSignRequest(x$0.j(0), x$0.j(1), x$0.j(2));
});
var $d_Lpresto_AgentView$LocalShodoSignRequest$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$LocalShodoSignRequest$, "presto.AgentView$LocalShodoSignRequest$", ({
  Em: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_AgentView$LocalShodoSignRequest$ as $d_Lpresto_AgentView$LocalShodoSignRequest$ };
var $n_Lpresto_AgentView$LocalShodoSignRequest$;
function $m_Lpresto_AgentView$LocalShodoSignRequest$() {
  if ((!$n_Lpresto_AgentView$LocalShodoSignRequest$)) {
    $n_Lpresto_AgentView$LocalShodoSignRequest$ = new $c_Lpresto_AgentView$LocalShodoSignRequest$();
  }
  return $n_Lpresto_AgentView$LocalShodoSignRequest$;
}
export { $m_Lpresto_AgentView$LocalShodoSignRequest$ as $m_Lpresto_AgentView$LocalShodoSignRequest$ };
//# sourceMappingURL=presto.-Agent-View$-Local-Shodo-Sign-Request$.js.map
